import axios from "axios";
import DOWNLOAD_FILE_FROM_DATABASE from "../../constants/downloadFileFromDatabase";

import { generateFileURL } from "./generateFileURL";

export const downloadFileFromMongoDB = (file: any) => {
	const fileURL = generateFileURL(file);
	axios({
		url: fileURL,
		method: "GET",
		responseType: "blob"
	}).then((response: any) => {
		const url = window.URL.createObjectURL(new Blob([response.data]));
		const link = document.createElement("a");
		link.href = url;
		file.mimetype === DOWNLOAD_FILE_FROM_DATABASE.PDF
			? link.setAttribute("download", "event_document.pdf")
			: file.mimetype === DOWNLOAD_FILE_FROM_DATABASE.DOC_FILE
			? link.setAttribute("download", "event_document.pdf")
			: file.mimetype === DOWNLOAD_FILE_FROM_DATABASE.DOCX_FILE
			? link.setAttribute("download", "event_document.docx")
			: file.mimetype === DOWNLOAD_FILE_FROM_DATABASE.XLS_FILE
			? link.setAttribute("download", "event_document.xls")
			: file.mimetype === DOWNLOAD_FILE_FROM_DATABASE.XLSX_FILE
			? link.setAttribute("download", "event_document.xlsx")
			: file.mimetype === DOWNLOAD_FILE_FROM_DATABASE.JPEG_IMAGE
			? link.setAttribute("download", "event_document.jpeg")
			: file.mimetype === DOWNLOAD_FILE_FROM_DATABASE.JPG_IMAGE
			? link.setAttribute("download", "event_document.jpg")
			: file.mimetype === DOWNLOAD_FILE_FROM_DATABASE.PNG_IMAGE
			? link.setAttribute("download", "event_document.png")
			: file.mimetype === DOWNLOAD_FILE_FROM_DATABASE.TEXT_FILE
			? link.setAttribute("download", "event_document.txt")
			: null;
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	});
};
